// extracted by mini-css-extract-plugin
export default {"homeContent":"HomePageContent_homeContent__TYK68","iconContainer":"HomePageContent_iconContainer__BO-Dr","descriptionText":"HomePageContent_descriptionText__Dzugj"};